import { useCallback, useEffect, useState } from "react"
import { listHistory } from "../services/history"
import useDataApi from "./useDataApi"
import { debounce } from "../utils/debounce"

const aCreatedTherms = [
  "created",
  "create",
  "criou",
  "cria",
  "criar",
  "criação",
  "criado",
  "criação do analito",
  "adicionou",
]
const aUpdatedTherms = [
  "alterou",
  "alteração",
  "alterado",
  "altera",
  "atualizou",
  "atualização",
  "atualizado",
  "atualiza",
  "atualizar",
  "alt",
  "update",
  "updated",
  "upd",
  "Mudou",
  "change",
  "obrigatoriedade",
  "mandatory"
]

const aRemovedTherms = [
  "remove",
  "removed",
  "removido",
  "removida",
  "removidos",
  "removidas",
  "remoção",
  "remover",
  "removendo",
  "removendo",
  "removidos",
  "deletado",
  "deletar",
  "deletou",
  "apagou",
  "apagar",

]
const aActiveTherms = ["active", "ativo", "ativou", "ativar", "atv"]
const aInactiveTherms = ["inactive", "inativo", "inativou"]
export default function useHistoric({ target_ctype, target_nid }) {
  const [aListHistoryData, fnFetchListHistory] = useDataApi(listHistory)
  const [aListHistory, fnSetAListHistory] = useState([])
  const [oListHistoryParams, fnSetListHistoryParams] = useState({ page: 1, per_page: 15 })
  const fnGetListHistory = useCallback(async () => {
    const order = target_ctype === "field" ? "opht_nid" : "opht_dcreated"
    const data = await fnFetchListHistory(
      order,
      target_ctype,
      target_nid,
      null,
      oListHistoryParams.page,
      oListHistoryParams.per_page,
    )

    if (aListHistory?.length === 0) fnSetAListHistory(data.data.data || [])
    if (aListHistory?.length > 0) fnSetAListHistory([...aListHistory, ...data.data.data])
    return data ? data.data.data : []
  }, [target_ctype, target_nid, oListHistoryParams])

  const searchValues = async (value) => {
    if (!value) return await fnGetListHistory()
    const days = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
    let search_text = null
    let search_type = null
    let search_status = null
    const valueLowerCase = value.toLowerCase().trim()

    days.forEach((item) => {
      if (valueLowerCase[0] == String(item)) {
        const [day, mounth, year] = valueLowerCase.split("/")

        if (Number(day) && Number(mounth) && Number(year) && year.length === 4) {
          search_text = `&search_text=${year}-${mounth}-${day}`
          search_type = null
          return
        }
      } else if (aCreatedTherms.some((therm) => valueLowerCase.includes(therm))) {
        search_type = "&search_type=created"
        search_text = null

        return
      } else if (aUpdatedTherms.some((therm) => valueLowerCase.includes(therm))) {
        search_type = "&search_type=update"
        search_text = null

        return
      }else if (aRemovedTherms.some((therm) => valueLowerCase.includes(therm))) {
        search_type = "&search_type=deleted"
        search_text = null

        return
      } 
      else if (aInactiveTherms.some((therm) => valueLowerCase.includes(therm))) {
        search_status = "&search_status=inactive"

        return
      } else if (aActiveTherms.some((therm) => valueLowerCase.includes(therm))) {
        search_status = "&search_status=active"

        return
      }
       else if (!days.includes(Number(valueLowerCase[0]))) {
        search_text = `&search_text=${encodeURIComponent(valueLowerCase)}`
        search_type = null
      } else if (valueLowerCase === "") {
        search_type = null
        search_text = null
      }
    })
    if (search_status) {
      fnFetchHistoryByStatus(search_status)
      return
    }
    fnFetchHistoryByParams(search_text, search_type)
  }
  const fnSearchHistory = debounce(searchValues, 500)

  const fnFetchHistoryByParams = async (searchText, searchType) => {
    const order = target_ctype === "field" ? "opht_nid" : "opht_dcreated"

    const { data } = await fnFetchListHistory(
      order,
      target_ctype,
      target_nid,
      searchText ?? searchType,
    )
    fnSetAListHistory(data?.data)
  }

  useEffect(() => {
    ;(async () => {
      await fnGetListHistory()
    })()
  }, [oListHistoryParams])

  const fnFetchHistoryByStatus = useCallback(
    async (searchStatus) => {
      const { data } = await fnFetchListHistory(target_ctype, target_nid, searchStatus)
      fnSetAListHistory(data?.data)
    },
    [target_ctype, target_nid, oListHistoryParams],
  )

  return {
    fnGetListHistory,
    fnSearchHistory,
    aListHistory,
    aListHistoryData,
    oListHistoryParams,
    fnSetListHistoryParams,
  }
}
